<template>
  <v-container fluid class="legal-entity">
    <v-row>
      <v-col cols="12" md="6">
        <CompanyInformation />
        <PermissionsCartable />
      </v-col>
      <v-col cols="12" md="6">
        <MemberList :members="members" />
        <v-card
          class="card pa-4 mt-4 "
          color="gray10"
          flat
          to="/legal-entity/terms"
        >
          <div class="d-flex align-center justify-space-between">
            <div class="d-flex align-center ">
              <div
                class="d-flex align-center justify-center gray7 rounded"
                style="width:35px;height:35px"
              >
                <v-icon>$editList</v-icon>
              </div>
              <div class="d-flex flex-column ms-2">
                <span class="font-Bold-14">
                  {{
                    $t(
                      "corporateAccount.corporateDashboard.legalCompaniesRules"
                    )
                  }}
                </span>
                <span class="gray3--text">
                  {{
                    $t(
                      "corporateAccount.corporateDashboard.legalCompaniesRulesDescription"
                    )
                  }}
                </span>
              </div>
            </div>
            <v-icon clr="var(--v-gray1-base)">$arrowLeft</v-icon>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CompanyInformation from "@/components/LegalEntityDashboard/CompanyInformation.vue";
import MemberList from "@/components/Shared/LegalEntity/MemberList.vue";
import PermissionsCartable from "@/components/Shared/LegalEntity/PermissionsCartable.vue";
import legalService from "@/services/modules/legalService";
export default {
  name: "LegalEntityDashboard",
  components: { CompanyInformation, MemberList, PermissionsCartable },
  data() {
    return {
      members: []
    };
  },
  mounted() {
    legalService
      .accountDetailsWithMember(this.$cookies.get("CA_ID"))
      .then(response => {
        this.members = response.data.data.members;
      });
  },
  methods: {}
};
</script>
